export enum TransactionRecoveryLogsRecoveryType {
  CHARGEBACK = 'CHARGEBACK',
  PRE_CHARGEBACK_ALERT = 'PRE_CHARGEBACK_ALERT',
  REFUND = 'REFUND',
}
